import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import type { Disaster } from '@/types/api/disaster/disaster'
import { queryDisasters } from '@/api/disaster/disasterDaoApiGwFuncs'
import { GlobalError } from '@/utils/globalError/globalError'
import { ERROR_CODES } from '@/constants/error/errorCode'
import MiiaFwConfig from '@/configs/config'

export const useDisasterStore = defineStore(
  'disasterStore',
  () => {
    const disaster = ref<Disaster | null>(null)
    const disasters = ref<Disaster[]>([])

    const setDisasters = (newDisasters: Disaster[]) => {
      disasters.value = newDisasters

      // 有効な災害IDをdisasterに格納
      const result = disasters.value.find(e => {
        return e.isEnabled
      })
      if (result !== undefined) {
        disaster.value = result
      } else {
        // 有効な災害がない
        throw new GlobalError([ERROR_CODES.DISASTER_INFO_NOT_SET])
      }
    }

    /**
     * 災害APIを呼び出し、値をセットする
     * @param param {govCode 自治体コード, viewCode 表示コード}
     */
    const fetchAndSetDisasters = async (param: {
      govCode: string | undefined
      viewCode?: string
    }) => {
      if (param === undefined || param.govCode === undefined || param.govCode === '') {
        throw new GlobalError([ERROR_CODES.DISASTER_INFO_FETCH_FAILED])
      }

      const disasterQueryParams = {
        system: MiiaFwConfig.config.sysId,
        govCode: param.govCode
      }
      const res = await queryDisasters(disasterQueryParams).catch(() => {
        throw new GlobalError([ERROR_CODES.DISASTER_INFO_FETCH_FAILED])
      })
      if (!res || !res.result) {
        throw new GlobalError([ERROR_CODES.DISASTER_INFO_NOT_SET])
      }
      setDisasters(res.result)
    }

    const govCode = computed(() => disaster.value?.govCode)
    const disasterId = computed(() => disaster.value?.disasterId)
    const disasterName = computed(() => disaster.value?.disasterName)
    const occurrenceDate = computed(() => disaster.value?.occurrenceDate)
    const isEnabled = computed(() => disaster.value?.isEnabled)

    const reset = () => {
      disaster.value = null
    }

    return {
      disaster,
      disasters,
      govCode,
      disasterId,
      disasterName,
      occurrenceDate,
      isEnabled,
      fetchAndSetDisasters,
      reset
    }
  },
  {
    persist: true
  }
)
